<template>
    <div class="b1">
        <div class="bg"></div>
        <div class="box">
            <div class="top">
                <div class="t_item">
                    <div>课程名称：</div>
                    <el-input placeholder="请输入内容" v-model="courseName"></el-input>
                </div>
                <div class="t_item">
                    <div>班级名称：</div>
                    <el-input placeholder="请输入内容" v-model="className"></el-input>
                </div>
                <div class="t_item">
                    <div>创建老师：</div>
                    <el-input placeholder="请输入内容" v-model="bzrName"></el-input>
                </div>
                <div class="t_item">
                    <div>状态：</div>
                    <el-select clearable v-model="status" placeholder="请选择" @clear="clearStatus">
                        <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="t_item">
                    <div>分析状态：</div>
                    <el-select clearable v-model="evaluateStatus" placeholder="请选择" @clear="clearEvaluateStatus">
                        <el-option v-for="item in evaluateStatusList" :key="item.value" :label="item.name" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="t_item">
                    <div>创建时间：</div>
                    <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="dateVal" type="daterange"
                        align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button type="primary" plain @click="reset">重置</el-button>
            </div>
            <div class="center">
                <div class="c_top">
                    <div class="ct_left">
                        我的课堂
                        <span>总数：{{ total }}</span>
                    </div>
                </div>
                <div class="c_bottom">
                    <div class="cb_top">
                        <div>课题</div>
                        <div>学科</div>
                        <div>状态</div>
                        <div>分析状态</div>
                        <div>二维码</div>
                        <div>评价内容</div>
                        <div>所属班级</div>
                        <div>创建老师</div>
                        <div>创建时间</div>
                    </div>
                    <div class="cb_list">
                        <div class="cb_bottom" v-for="(item, index) in list" :key="index" @click="$router.push({ path: '/classroomInfoManage', query: { id: item.id } })">
                            <div class="cbb_2">{{ item.courseName }}</div>
                            <div class="cbb_2">{{ item.subjectName }}</div>
                            <div class="cbb_3">
                                <div class="bb3" :class="item.status == 0 ? 'cbb_s1' : item.status == 1 ? 'cbb_s2' : 'cbb_s3'">{{ item.status == 0 ? '使用中' : item.status == 1 ? '已结课' : '待上课' }}</div>
                            </div>
                            <div class="cbb_3">
                                <div class="bb3" :class="item.evaluateStatus == 0 ? 'cbb_e2' : item.evaluateStatus == 1 ? 'cbb_e3' : item.evaluateStatus == 2 ? 'cbb_e1' : 'cbb_e4'">
                                    {{ item.evaluateStatus == 0 ? '未评价' : item.evaluateStatus ==
                                1 ? '评价中' : item.evaluateStatus == 2 ? '评价成功' : '评价失败' }}
                                </div>
                            </div>
                            <div class="cbb_4">
                                <img :src="webImg + item.qrCode" />
                            </div>
                            <div class="cbb_5 line2_">{{ item.evaluate }}</div>
                            <div class="cbb_6">{{ item.className }}</div>
                            <div class="cbb_7">{{ item.bzrName }}</div>
                            <div class="cbb_8">{{ item.createTime }}</div>
                        </div>
                        <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
                    </div>
                </div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNum" :page-sizes="[10, 30, 50]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { schoolCourseList } from '../../apis/index'
export default {
    data() {
        return {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            list: [],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dateVal: null,
            courseName: '',
            className: '',
            bzrName: '',
            status: null,//状态 0-使用中 1-结束使用 2-上课前
            evaluateStatus: null,//分析状态 0-未评价 1-评价中 2-评价成功 3-评价失败
            statusList:[{name: '使用中', value: 0},{name: '结束使用', value: 1},{name: '上课前', value: 2}],
            evaluateStatusList:[{name: '未评价', value: 0},{name: '评价中', value: 1},{name: '评价成功', value: 2},{name: '评价失败', value: 3}],
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        clearEvaluateStatus(){
            this.evaluateStatus = null
        },
        clearStatus(){
            this.status = null
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageNum = 1
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val
            this.getList()
        },
        search() {
            setTimeout(() => {
                this.pageNum = 1
                this.getList()
            }, 500);
        },
        reset() {
            this.courseName = ''
            this.className = ''
            this.bzrName = ''
            this.dateVal = null
            this.status = null
            this.evaluateStatus = null
            this.pageNum = 1
            this.getList()
        },
        getList() {
            schoolCourseList(this.pageNum, this.pageSize, { courseType: 1, courseName: this.courseName, className: this.className, bzrName: this.bzrName, status: this.status, evaluateStatus: this.evaluateStatus, dateVal: this.dateVal }).then(res => {
                console.log(res, 'schoolCourseList');
                if (this.pageNum == 1) {
                    this.list = []
                }
                this.total = res.total
                this.list = res.data
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.line1_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.line2_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
::v-deep {
    .el-select {
        width: 100%;
    }

    .el-input__inner,
    .el-range-input {
        font-size: 12px;
    }
}

.b1 {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }
}

.box {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 40px 0;

    .top {
        width: 100%;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;

        .t_item {
            width: 300px;
            display: flex;
            align-items: center;
            margin-right: 40px;
            margin-bottom: 20px;

            div {
                white-space: nowrap;
                font-weight: 400;
                font-size: 11px;
                color: #333333;
            }
        }
    }

    .center {
        width: 100%;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .c_top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 40px 0;
            margin-top: 20px;

            .ct_left {
                display: flex;
                align-items: center;
                font-weight: bold;
                font-size: 18px;
                color: #000000;

                span {
                    font-weight: 500;
                    font-size: 12px;
                    color: #999999;
                    margin-left: 18px;
                }
            }

            .ct_right {
                width: 92px;
                height: 32px;
                background: #399AFF;
                border-radius: 7px 7px 7px 7px;
                font-weight: 800;
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
                line-height: 32px;
                user-select: none;
                cursor: pointer;
            }
        }

        .c_bottom {
            width: 100%;
            height: 0;
            flex: 1;
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;

            .cb_top {
                width: 100%;
                border-radius: 4px;
                background: #F4F6FB;
                display: flex;
                align-items: center;
                font-weight: bold;
                font-size: 12px;
                color: #657688;
                box-sizing: border-box;
                padding: 15px 12px;
                padding-right: 29px;

                div {
                    flex: 1;
                    box-sizing: border-box;
                        padding: 0 12px;
                }

                div:nth-child(6) {
                    flex: 1.5;
                }
            }

            .cb_list::-webkit-scrollbar {
                // display: none;
                // position: absolute;
            }

            .cb_list {
                width: 100%;
                height: 0;
                flex: 1;
                overflow-y: scroll;

                .cb_bottom {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #F2F3F5;
                    // background-color: #fff;
                    box-sizing: border-box;
                    padding: 20px 15px;

                    .cbb_s1 {
                        width: fit-content !important;
                        padding: 5px;
                        box-sizing: border-box;
                        font-weight: 500;
                        font-size: 12px;
                        color: #27C189;
                        background: #D7FFE6;
                        border-radius: 6px 6px 6px 6px;
                    }
                    .cbb_s2 {
                        width: fit-content !important;
                        padding: 5px;
                        box-sizing: border-box;
                        font-weight: 500;
                        font-size: 12px;
                        color: #999999;
                        background: #ECECEC;
                        border-radius: 6px 6px 6px 6px;
                    }
                    .cbb_s3 {
                        width: fit-content !important;
                        padding: 5px;
                        box-sizing: border-box;
                        font-weight: 500;
                        font-size: 12px;
                        color: #FF9125;
                        background: #FFECD9;
                        border-radius: 6px 6px 6px 6px;
                    }
                    .cbb_e1{
                        width: fit-content !important;
                        padding: 5px;
                        box-sizing: border-box;
                        font-weight: 500;
                        font-size: 12px;
                        color: #27C189;
                        background: #D7FFE6;
                        border-radius: 6px 6px 6px 6px;
                    }
                    .cbb_e2{
                        width: fit-content !important;
                        padding: 5px;
                        box-sizing: border-box;
                        font-weight: 500;
                        font-size: 12px;
                        color: #4385FF;
                        background: #DFEAFF;
                        border-radius: 6px 6px 6px 6px;
                    }
                    .cbb_e3{
                        width: fit-content !important;
                        padding: 5px;
                        box-sizing: border-box;
                        font-weight: 500;
                        font-size: 12px;
                        color: #FF9125;
                        background: #FFECD9;
                        border-radius: 6px 6px 6px 6px;
                    }
                    .cbb_e4{
                        width: fit-content !important;
                        padding: 5px;
                        box-sizing: border-box;
                        font-weight: 500;
                        font-size: 12px;
                        color: #FF2525;
                        background: #FFE7E7;
                        border-radius: 6px 6px 6px 6px;
                    }

                    div {
                        flex: 1;
                        box-sizing: border-box;
                        padding: 0 10px;
                    }

                    div:nth-child(6) {
                        flex: 1.5;
                    }

                    .cbb_4 {
                        flex: 1;
                        display: flex;
                        flex-direction: column;

                        // align-items: center;
                        img {
                            width: 50px;
                            height: 50px;
                            cursor: pointer;
                        }
                    }
                    .cbb_5{
                        flex: 1.5;
                        
                    }

                }
            }

        }
    }
}
</style>